import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FaUserPlus, FaTimes, FaSignInAlt } from 'react-icons/fa';
import { STORAGE_KEYS } from '../../utils/constants';
import './SignupPromptModal.css';

/**
 * SignupPromptModal — Kayıt Duvarı (registration wall) modalı.
 *
 * Misafir kullanıcı bir AI sorgusu başlattığında (isim öneri formu, isim
 * anlamı arama, kişilik/uyum/İslami analiz vb.) sorgu AI'ye GÖNDERİLMEZ;
 * arka plan blur'lanır ve bu modal açılır.
 *
 * Düzen (istek üzerine sadeleştirildi): başlık → alt yazı → spinner →
 * butonlar. Ara içerik (mesaj paragrafı, fayda listesi, hediye ikonu)
 * kaldırıldı.
 *
 * Kayıt/giriş sonrası:
 *   - REDIRECT_AFTER_AUTH sayesinde kullanıcı aynı sayfaya döner,
 *   - bekleyen (pending) sorgu otomatik yeniden gönderilir,
 *   - misafirin başlattığı ilk sorgu günlük 1/3 olarak sayılır →
 *     o gün 2 hakkı daha kalır.
 */
const SignupPromptModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const goSignup = () => {
    localStorage.setItem(STORAGE_KEYS.REDIRECT_AFTER_AUTH, window.location.pathname + window.location.search);
    onClose();
    navigate('/register');
  };

  const goLogin = () => {
    localStorage.setItem(STORAGE_KEYS.REDIRECT_AFTER_AUTH, window.location.pathname + window.location.search);
    onClose();
    navigate('/login');
  };

  const goHome = () => {
    onClose();
    navigate('/');
  };

  return (
    <div className="signup-prompt-overlay" onClick={onClose}>
      <div className="signup-prompt-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="signup-prompt-close"
          onClick={onClose}
          aria-label={t('signupPrompt.close', 'Kapat')}
        >
          <FaTimes />
        </button>

        <div className="signup-prompt-header">
          <h2 className="signup-prompt-title">
            {t('signupPrompt.title', 'Talebin hazırlanıyor.')}
          </h2>
          <p className="signup-prompt-subtitle">
            {t('signupPrompt.subtitle', 'Kayıt olduktan sonra sonuçlarını göreceksin')}
          </p>
        </div>

        <div
          className="signup-prompt-spinner"
          role="status"
          aria-label={t('signupSpinner.preparing', 'Hazırlanıyor')}
        />

        <div className="signup-prompt-footer">
          <button
            type="button"
            className="signup-prompt-cta"
            onClick={goSignup}
          >
            <FaUserPlus />
            <span>{t('signupPrompt.cta', 'Hemen Kayıt Ol — Ücretsiz')}</span>
          </button>
          <button
            type="button"
            className="signup-prompt-login-link"
            onClick={goLogin}
          >
            <FaSignInAlt />
            <span>{t('signupPrompt.loginLink', 'Zaten hesabın var mı? Giriş yap')}</span>
          </button>
          <button
            type="button"
            className="signup-prompt-secondary"
            onClick={goHome}
          >
            {t('signupPrompt.later', 'Ana sayfa')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupPromptModal;
